export const credentialingVersion = '8.3.0';
